// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__oaMo9","form":"styles_form__3XZ9v"};